export enum ReportSubjectTypeEnum {
  PRODUCTS = 'PRODUCTS',
  CUSTOMERS = 'CUSTOMERS',
  EMPLOYEES = 'EMPLOYEES',
  VENDORS = 'VENDORS',
  GENERAL_PRODUCTS = 'GENERAL_PRODUCTS',
}
